/**
 * Конфигурация подгрупп (подразделов) для визуального разделения в матрице прав
 * Позволяет логически группировать гранулярные разрешения внутри модулей
 */
export const PERMISSION_SUBGROUPS_CONFIG: Record<string, string> = {
  // ─── Модуль: Отчеты и аналитика ─────────────────────────────
  'reports.fill_monitoring': 'Заполнение (Мониторинг сдачи отчетов)',
  'reports.fill_monitoring.date_limit': 'Заполнение (Мониторинг сдачи отчетов)',
  'reports.fill_monitoring.protect_copy': 'Заполнение (Мониторинг сдачи отчетов)',

  'reports.edit_daily': 'Редактирование дневного отчета',
  'reports.edit_daily.date_limit': 'Редактирование дневного отчета',
  'reports.edit_daily.protect_copy': 'Редактирование дневного отчета',

  'reports.edit_monthly': 'Редактирование месячного отчета',
  'reports.edit_monthly.date_limit': 'Редактирование месячного отчета',
  'reports.edit_monthly.protect_copy': 'Редактирование месячного отчета',

  'reports.view_summary': 'Сводный отчет за период (Отчет)',
  'reports.view_summary.excel_export': 'Сводный отчет за период (Отчет)',
  'reports.view_summary.cash_report': 'Сводный отчет за период (Отчет)',
  'reports.view_summary.bank_report': 'Сводный отчет за период (Отчет)',
  'reports.view_summary.protect_copy': 'Сводный отчет за период (Отчет)',

  'reports.view_director': 'Директорский отчет (Дир. отчет)',
  'reports.view_director.excel_export': 'Директорский отчет (Дир. отчет)',
  'reports.view_director.protect_copy': 'Директорский отчет (Дир. отчет)',

  'reports.delivery.view': 'Сверка доставок',
  'reports.delivery.manage_terminals': 'Сверка доставок',
  'reports.delivery.protect_copy': 'Сверка доставок',

  'reports.math.view': 'Мат. отчет: Вход и защита',
  'reports.math.protect_copy': 'Мат. отчет: Вход и защита',

  'reports.math.report.view': 'Мат. отчет: Вкладка «Отчет»',
  'reports.math.report.edit_cells': 'Мат. отчет: Вкладка «Отчет»',
  'reports.math.report.check_status': 'Мат. отчет: Вкладка «Отчет»',
  'reports.math.report.create': 'Мат. отчет: Вкладка «Отчет»',
  'reports.math.report.reindex': 'Мат. отчет: Вкладка «Отчет»',
  'reports.math.report.recalculate': 'Мат. отчет: Вкладка «Отчет»',
  'reports.math.report.download': 'Мат. отчет: Вкладка «Отчет»',

  'reports.math.changes.view': 'Мат. отчет: Вкладка «Изменения»',
  'reports.math.changes.mark_checked': 'Мат. отчет: Вкладка «Изменения»',
  'reports.math.changes.mark_all': 'Мат. отчет: Вкладка «Изменения»',
  'reports.math.changes.copy_whatsapp': 'Мат. отчет: Вкладка «Изменения»',

  'reports.math.fields.view': 'Мат. отчет: Вкладка «Отображение»',
  'reports.math.fields.create': 'Мат. отчет: Вкладка «Отображение»',
  'reports.math.fields.edit': 'Мат. отчет: Вкладка «Отображение»',
  'reports.math.fields.delete': 'Мат. отчет: Вкладка «Отображение»',

  'reports.history.view': 'История изменений',
  'reports.history.pharmacies': 'История изменений',
  'reports.history.details': 'История изменений',

  // ─── Модуль: Главная (виджеты) ──────────────────────────────
  'home.revenue.view': 'Виджет: Выручка за неделю',
  'home.notifications.view': 'Виджет: Последние уведомления',
  'home.documents.incoming.view': 'Виджет: Входящие документы',
  'home.documents.incoming.limit': 'Виджет: Входящие документы',
  'home.documents.statuses.view': 'Виджет: Последние статусы документов',
  'home.documents.statuses.limit': 'Виджет: Последние статусы документов',
  'home.documents.recent.view': 'Виджет: Последние документы',
  'home.documents.recent.limit': 'Виджет: Последние документы',
  'home.documents.attention.view': 'Виджет: Документы, требующие внимания',
  'home.documents.attention.limit': 'Виджет: Документы, требующие внимания',
  'home.promotions.view': 'Виджет: Акции',
  'home.report_today.view': 'Виджет: Отчёт за сегодня',
  'home.documents.receiving.view': 'Виджет: Ожидают действия',
  'home.documents.problem.view': 'Виджет: Проблемные документы',
  'home.documents.problem.limit': 'Виджет: Проблемные документы',
  'home.journal.expiry.view': 'Виджет: Журнал сроков',
  'home.journal.expiry.limit': 'Виджет: Журнал сроков',
  'home.reports.submission.view': 'Виджет: Сдача отчётов',
  'home.reports.submission.limit': 'Виджет: Сдача отчётов',
  'home.network_revenue.view': 'Виджет: Выручка сети',
  'home.quick_links.view': 'Виджет: Быстрые ссылки',

  // ─── Модуль: Таблицы и справочники ──────────────────────────
  'tables.revenue.view': 'Таблица выручки',
  'tables.revenue.create': 'Таблица выручки',
  'tables.revenue.edit': 'Таблица выручки',
  'tables.revenue.delete': 'Таблица выручки',
  'tables.revenue.formula.edit': 'Таблица выручки',
  'tables.revenue.sync.view': 'Таблица выручки',
  'tables.revenue.sync.run': 'Таблица выручки',
  'tables.revenue.lock.view': 'Таблица выручки',
  'tables.revenue.lock.release': 'Таблица выручки',
  'tables.revenue.recalc.preview': 'Таблица выручки',
  'tables.revenue.recalc.run': 'Таблица выручки',
  'tables.revenue.entry.view': 'Окно ввода',
  'tables.revenue.entry.schedule': 'Окно ввода',
  'tables.revenue.entry.extend': 'Окно ввода',
  'tables.revenue.entry.unlock': 'Окно ввода',
  'tables.revenue.entry.personal': 'Окно ввода',
  'tables.revenue.entry.date': 'Окно ввода',
  'tables.revenue.entry.date_network': 'Окно ввода',
  'tables.regions.view': 'Справочник регионов',
  'tables.regions.create': 'Справочник регионов',
  'tables.regions.edit': 'Справочник регионов',
  'tables.regions.delete': 'Справочник регионов',
  'tables.math_fields.view': 'Поля мат. отчета',
  'tables.math_fields.create': 'Поля мат. отчета',
  'tables.math_fields.edit': 'Поля мат. отчета',
  'tables.math_fields.delete': 'Поля мат. отчета',

  // ─── Модуль: Пользователи ───────────────────────────────────
  'users.view': 'Просмотр и списки',
  'users.view_iin': 'Просмотр и списки',
  'users.view_activity': 'Просмотр и списки',
  'users.edit_profile': 'Редактирование профиля',
  'users.edit_role': 'Редактирование профиля',
  'users.edit_pharmacy': 'Редактирование профиля',
  'users.edit_password': 'Аутентификация и безопасность',
  'users.reset_biometrics': 'Аутентификация и безопасность',
  'users.toggle_status': 'Управление доступом',
  'users.impersonate': 'Управление доступом',
  'users.delete': 'Управление доступом',
  'users.staff.view': 'Подчинённые учётки точек',
  'users.staff.create': 'Подчинённые учётки точек',
  'users.staff.edit_permissions': 'Подчинённые учётки точек',
  'users.staff.reset_password': 'Подчинённые учётки точек',
  'users.staff.block': 'Подчинённые учётки точек',
  'users.staff.sessions': 'Подчинённые учётки точек',
  'users.staff.audit': 'Подчинённые учётки точек',
  'users.staff.impersonate': 'Подчинённые учётки точек',

  // ─── Модуль: Сотрудники точки (кабинет /dashboard) ──────────
  'staff.create': 'Создание и лимит',
  'staff.create.limit': 'Создание и лимит',
  'staff.edit_permissions': 'Управление учётками',
  'staff.reset_password': 'Управление учётками',
  'staff.block': 'Управление учётками',
  'staff.sessions': 'Управление учётками',
  'staff.audit': 'Управление учётками',

  // ─── Модуль: Создание пользователей ─────────────────────────
  'users.create': 'Создание пользователей',
  'users.create_role_scope': 'Параметры и доступные роли',

  // ─── Модуль: Документы и табели ─────────────────────────────
  'documents.invoices.view': 'Документы: просмотр и суммы',
  'documents.invoices.view_doc_amount': 'Документы: просмотр и суммы',
  'documents.invoices.view_item_amounts': 'Документы: просмотр и суммы',
  'documents.invoices.view_marks': 'Документы: КМ, история и экспорт',
  'documents.invoices.view_series': 'Документы: КМ, история и экспорт',
  'documents.invoices.view_history': 'Документы: КМ, история и экспорт',
  'documents.invoices.view_audit': 'Документы: КМ, история и экспорт',
  'documents.invoices.export': 'Документы: КМ, история и экспорт',
  'documents.invoices.export_marks': 'Документы: КМ, история и экспорт',
  'documents.invoices.retry': 'Документы: действия с документом',
  'documents.invoices.hide': 'Документы: действия с документом',
  'documents.invoices.reject': 'Документы: действия с документом',
  'documents.invoices.delete_draft': 'Документы: действия с документом',
  'documents.invoices.export_1c': 'Документы: действия с документом',
  'documents.invoices.warnings': 'Проблемные документы на контроле',
  'documents.invoices.warnings_actions': 'Проблемные документы на контроле',
  'documents.invoices.warnings_export': 'Проблемные документы на контроле',
  'documents.invoices.analytics': 'Аналитика документов',
  'documents.invoices.analytics_timeline': 'Аналитика документов',
  'documents.invoices.analytics_leadtime': 'Аналитика документов',
  'documents.invoices.analytics_pharmacies': 'Аналитика документов',
  'documents.invoices.analytics_heatmap': 'Аналитика документов',
  'documents.invoices.analytics_cleanup': 'Аналитика документов',
  'documents.invoices.analytics_products': 'Аналитика документов',
  'documents.invoices.settings': 'Настройки документов',
  'documents.marking.view': 'КМ\'ы',
  'documents.marking.export': 'КМ\'ы',
  'documents.flow.view': 'Документооборот',

  // ─── Кабинет аптеки (/dashboard): вкладки меню ──────────────
  'reports.current.view': 'Текущий отчет',
  'reports.monthly.view': 'Отчет за месяц',
  'monitoring.cash.view': 'Касса',
  'monitoring.km.view': 'КМ',

  // ─── Модуль: Табель РБ ──────────────────────────────────────
  'timesheet.data': 'Табель РБ',
  'timesheet.open': 'Табель РБ',
  'timesheet.settings': 'Табель РБ',

  // ─── Модуль: Журнал сроков ──────────────────────────────────
  'journal.view': 'Журнал сроков',
  'journal.analytics.view': 'Журнал сроков',
  'journal.export': 'Журнал сроков',
  'journal.create': 'Журнал сроков',
  'journal.edit': 'Журнал сроков',
  'journal.delete': 'Журнал сроков',

  // ─── Модули: Остатки и Справочник (коды guide.*) ────────────
  'guide.remains.view': 'Остатки',
  'guide.remains.prices': 'Остатки',
  'guide.remains.sums': 'Остатки',
  'guide.remains.contacts': 'Остатки',
  'guide.remains.km_details': 'Остатки',
  'guide.remains.export': 'Остатки',
  'guide.remains.refresh': 'Остатки',
  'guide.nomenclature.view': 'Справочник',
  'guide.nomenclature.export': 'Справочник',
  'guide.nomenclature.refresh': 'Справочник',

  // ─── Модуль: Журнал действий ────────────────────────────────
  'audit.view': 'Просмотр журнала',
  'audit.details.view': 'Просмотр журнала',
  'audit.export': 'Выгрузка и очистка',
  'audit.cleanup': 'Выгрузка и очистка',

  // ─── Модуль: Системные настройки ────────────────────────────
  'system.roles.manage': 'Безопасность и роли',
  'system.logs.view': 'Безопасность и роли',
  'system.db_table.manage': 'База данных',
  'system.dangerous.execute': 'База данных',
  'system.whatsapp.manage': 'Службы и оповещения',
  'system.notifications.send': 'Службы и оповещения',
  'system.tasks.manage': 'Служебные процессы'
};

/**
 * Якоря бокового меню конструктора: подгруппа → название пункта (как в боковом меню панели).
 * Несколько подгрупп с одним названием сливаются в один якорь (ведёт к первой карточке).
 */
export const SUBGROUP_ANCHOR_LABELS: Record<string, string> = {
  'Заполнение (Мониторинг сдачи отчетов)': 'Заполнение',
  'Редактирование дневного отчета': 'Редактирование',
  'Редактирование месячного отчета': 'Ред. мес. отчет',
  'Сводный отчет за период (Отчет)': 'Отчет',
  'Директорский отчет (Дир. отчет)': 'Дир. отчет',
  'Сверка доставок': 'Сверка доставок',
  'Мат. отчет: Вход и защита': 'Мат. отчет',
  'Мат. отчет: Вкладка «Отчет»': 'Мат. отчет',
  'Мат. отчет: Вкладка «Изменения»': 'Мат. отчет',
  'Мат. отчет: Вкладка «Отображение»': 'Мат. отчет',
  'История изменений': 'История',
  'Виджет: Последние уведомления': 'Уведомления',
  'Виджет: Входящие документы': 'Входящие документы',
  'Виджет: Последние статусы документов': 'Последние статусы',
  'Документы: просмотр и суммы': 'Документы',
  'Документы: КМ, история и экспорт': 'КМ и экспорт',
  'Документы: действия с документом': 'Действия с документом',
  'Проблемные документы на контроле': 'Проблемные документы',
  'Аналитика документов': 'Аналитика',
  'Настройки документов': 'Настройки',
  'Подчинённые учётки точек': 'Подчинённые учётки'
};

/** Название якоря для главного переключателя модуля (`<module>.menu`) */
export const MASTER_ANCHOR_LABELS: Record<string, string> = {
  home: 'Пункт меню',
  reports: 'Пункт меню',
  audit: 'Пункт меню',
  create_account: 'Создание пользователей'
};
export const DEFAULT_MASTER_ANCHOR_LABEL = 'Пункт меню';

export function getAnchorLabel(subgroupName: string): string {
  return SUBGROUP_ANCHOR_LABELS[subgroupName] || subgroupName;
}

/**
 * Получение названия подгруппы для права
 */
export function getPermissionSubgroup(code: string): string | null {
  if (PERMISSION_SUBGROUPS_CONFIG[code]) {
    return PERMISSION_SUBGROUPS_CONFIG[code];
  }

  // Автоматическая группировка по префиксам для отчетов (исключает попадание в «Общие разрешения»)
  if (code.startsWith('reports.fill_monitoring')) return 'Заполнение (Мониторинг сдачи отчетов)';
  if (code.startsWith('reports.edit_daily')) return 'Редактирование дневного отчета';
  if (code.startsWith('reports.edit_monthly')) return 'Редактирование месячного отчета';
  if (code.startsWith('reports.view_summary')) return 'Сводный отчет за период (Отчет)';
  if (code.startsWith('reports.view_director')) return 'Директорский отчет (Дир. отчет)';
  if (code.startsWith('reports.delivery')) return 'Сверка доставок';
  if (code.startsWith('reports.history')) return 'История изменений';
  if (code.startsWith('reports.math.report')) return 'Мат. отчет: Вкладка «Отчет»';
  if (code.startsWith('reports.math.changes')) return 'Мат. отчет: Вкладка «Изменения»';
  if (code.startsWith('reports.math.fields')) return 'Мат. отчет: Вкладка «Отображение»';
  if (code.startsWith('reports.math')) return 'Мат. отчет: Вход и защита';

  return null;
}
